import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import loopstudio from "../../Assets/Projects/loopstudio.jpg";
import drug from "../../Assets/Projects/drug.jpg";
import CoLawer from "../../Assets/Projects/CoLawer.jpg";
import movie from "../../Assets/Projects/movie.jpg";
import svu from "../../Assets/Projects/svu.jpg";
import notes_maker from "../../Assets/Projects/notes maker.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={movie}
              isBlog={false}
              title="MyCima"
              description="Developed a responsive movie website using React, axios for API integration, React Routing for seamless navigation, and React Bootstrap for enhanced UI components. Implemented with HTML and CSS for structure and styling. The project offers a user-friendly interface optimized for various devices, providing cinema enthusiasts with an immersive viewing experience."
              ghLink="https://github.com/Ahmed-Nadyy/MyMovie-ReactWebsite"
              demoLink="https://ahmed-nadyy.github.io/MyMovie-ReactWebsite/"
              LinkedLink="https://www.linkedin.com/posts/ahmed-nady-742a18240_webdevelopment-react-movies-activity-7174866071970058240-oXHC?utm_source=share&utm_medium=member_desktop"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={notes_maker}
              isBlog={false}
              title="Notes Maker"
              description="Developed a user-friendly notes management website using React, designed for creating and organizing notes effortlessly. Implemented features include the ability to create unlimited notes and delete them seamlessly through a simple and intuitive interface."
              ghLink="https://github.com/Ahmed-Nadyy/Notes-Maker-ReactWebsite"
              demoLink="https://notes-maker-site.netlify.app/"
              LinkedLink="https://www.linkedin.com/posts/ahmed-nady-742a18240_react-webdev-notetaking-activity-7173404791610490881-fE5i?utm_source=share&utm_medium=member_desktop"

            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={CoLawer}
              isBlog={false}
              title="Co-Lawer"
              description="Our AI-powered legal assistance platform is designed to revolutionize the way legal professionals and law students access and utilize legal information. Leveraging advanced natural language processing (NLP) technology, the platform can understand and respond to complex legal queries, providing accurate and contextually relevant answers in real-time."
              ghLink="https://github.com/Ahmed-Nadyy/Co-Lawyer_AI_assistant"
              demoLink="https://colawyer-ai.netlify.app/"
              // LinkedLink="https://www.linkedin.com/posts/ahmed-nady-742a18240_webdevelopment-react-movies-activity-7174866071970058240-oXHC?utm_source=share&utm_medium=member_desktop"

            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={loopstudio}
              isBlog={false}
              title="loopstudios_website_clone"
              description="loopstudios_website_clone is a website I built from scratch using HTML, CSS, and JavaScript."
              ghLink="https://github.com/Ahmed-Nadyy"
              demoLink="https://ahmed-nadyy.github.io/loopstudios_website_clone/"
              LinkedLink="https://www.linkedin.com/posts/ahmed-nady-742a18240_webdevelopment-html-css-activity-7166501627661541377-LmQ5?utm_source=share&utm_medium=member_desktop"

            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={svu}
              isBlog={false}
              title="Exam Control Management System (CMS)"
              description="Developed an innovative Exam Control Management System for South Valley University,
enhancing the efficiency of managing exam processes across the university."
              ghLink="https://github.com/SABRY225/Control-System"
              LinkedLink="https://www.linkedin.com/posts/ahmed-nady-742a18240_teamwork-universityprojects-react-activity-7206735801248886784-iE3F?utm_source=share&utm_medium=member_desktop"

            // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={drug}
              isBlog={false}
              title="Drug Detection AI Project"
              description="Developed a Flask web application integrated with a Python-based Decision Tree model for
predicting optimal drug choices based on user-inputted features. This project enhances
healthcare decision-making by providing personalized drug recommendations through a
user-friendly interface"
              ghLink="https://github.com/Ahmed-Nadyy/drugDetection_flask_app"
              LinkedLink="https://www.linkedin.com/posts/ahmed-nady-742a18240_machinelearning-datascience-flask-activity-7149493691563270145-VSxP?utm_source=share&utm_medium=member_desktop"
              
            // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
